import {z} from 'zod';

export const epochTimestamp = z.number().int().min(0);
